/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：440
 */

module.exports = {
  container: "style_container__183ev",
  list: "style_list__1Af5y",
  row: "style_row__NYFVb",
  keyItem: "style_keyItem__20v0N",
  valueItem: "style_valueItem__qgvmy",
  input: "style_input__3U8wb",
  error: "style_error__3R2Gs",
  close: "style_close__2Vd7T",
  focus: "style_focus__3T0Qp",
  footer: "style_footer__1ZIah",
  tips: "style_tips__3mn2P",
  save: "style_save__278Pv"
}
